// @ts-nocheck
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import viewUI from "view-design";
import axios from "axios";
import urlobj from "./api/index";
import VueCropper from "vue-cropper";
import VueLazyload from "vue-lazyload";
import InfiniteLoading from "vue-infinite-loading"; // 滚动加载

import { Image, Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui';
import _ from "lodash";
import "view-design/dist/styles/iview.css";
import "./assets/css/base.css";
import util from "./utils/util";
import 'element-ui/lib/theme-chalk/index.css';
import "./my-theme/index.less"; // iview 主题色

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import VueQuillEditor from "vue-quill-editor";
import AMap from "vue-amap";

// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
/**解决多色图标使用 */
import "./assets/iconfont/iconfont.js";


Vue.component('ElImage', Image)
Vue.component('ElDropdown', Dropdown);
Vue.component('ElButton', Button);
Vue.component('ElDropdownMenu', DropdownMenu);
Vue.component('ElDropdownItem', DropdownItem);
Vue.use(VueAwesomeSwiper);

// import 'lib-flexible'
Vue.use(VueQuillEditor);

// import {installCardDragger} from 'carddragger'
// Vue.use(installCardDragger)
/* 注册滚动加载组件 BEGIN */
Vue.use(InfiniteLoading, {
  props: {
    distance: 300,
    spinner: "bubbles"
  }
});

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 99999,
  }
})

/* 注册滚动加载组件 END */
Vue.use(VueLazyload, {
  preLoad: 1, // 预加载高度的比例
  error: require("./assets/images/error.png"), // 图像的src加载失败
  loading: require("./assets/images/lazyload.jpg"), // src的图像加载
  attempt: 1 // 尝试计数
});

Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.use(viewUI);
Vue.use(VueCropper);

// lodash
Vue.prototype._ = _;

// 配合 iview spin 使用
Vue.prototype.$showLoading = function () {
  store.commit("updateSpinShow", true);
};
Vue.prototype.$hideLoading = function () {
  store.commit("updateSpinShow", false);
};

// 请求封装 开始
let http = config => {
  let http_config = {
    url: config.url,
    headers: Object.assign(
      {
        "X-Requested-With": "XMLHttpRequest",
        token: store.state.access_token || ""
      },
      config.header
    ),
    method: config.method
  };

  if (config.method === "get") {
    http_config.params = config.data;
  } else if (config.method === "delete") {
    http_config.params = config.data;
    http_config.data = config.data;
  } else {
    http_config.data = config.data;
  }

  axios(http_config)
    .then(request => {
      if (request.data.code === 90005) {
        store.commit("updateSpinShow", false);
        if (
          window.location.host.indexOf("localhost") > -1 ||
          window.location.host.indexOf("ceshi.shequyun") > -1 ||
          window.location.host.indexOf("py.shequyun") > -1
        ) {
          router.push({
            path: "/"
          });
        } else {
          router.push({
            path: "/NewLogin"
          });
        }

        return;
      }

      if (request.data.length) {
        config.success && config.success(request.data);
        return;
      }
      if (request.data.isSucceed) {
        config.success && config.success(request.data);
      } else if (request.data != undefined && request.data != null) {
        config.success && config.success(request.data);
      } else {
        store.commit("updateSpinShow", false);
        Vue.prototype.$Message.error(request.data.message);
        config.error && config.error(request);
      }
    })
    .catch(e => {
      store.commit("updateSpinShow", false);
      Vue.prototype.$Message.error("请求失败，请重试");
      config.error && config.error(e);
    });
};

let get = (url, data, header = {}) => {
  return new Promise((resolve, reject) => {
    http({
      url,
      method: "get",
      data,
      header,
      success: request => {
        resolve(request);
      },
      error: e => {
        reject(e);
      }
    });
  });
};

let post = (url, data, header = {}) => {
  return new Promise((resolve, reject) => {
    http({
      url,
      data,
      header,
      method: "post",
      success: request => {
        resolve(request);
      },
      error: e => {
        reject(e);
      }
    });
  });
};
/* delete 方法 */
let del = (url, data) => {
  return new Promise((resolve, reject) => {
    http({
      url,
      method: "delete",
      data,
      success: request => {
        resolve(request);
      },
      error: e => {
        reject(e);
      }
    });
  });
};
/* 请求封装 结束 */

Vue.prototype.$axios = axios;
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$delete = del;
Vue.prototype.$bus = new Vue();
Vue.prototype.urlobj = urlobj;
Vue.prototype.$util = util;

Vue.prototype.qs = require("qs");

Vue.config.productionTip = false;

/* 高德地图 开始 */
// Vue.use(AMap);
// AMap.initAMapApiLoader({
//   // key: '238db1d2556b07c109516eb720e08f47',
//   // key: 'fb49c6761ac1fa59d69e0d54ba47a918',
//   key: "fe26968ffb0417abb6d7ca1c686909d4",
//   uiVersion: "1.0.11", // 版本号
//   plugin: [
//     "AMap.DistrictSearch",
//     "AMap.Autocomplete",
//     "AMap.PlaceSearch",
//     "AMap.Scale",
//     "AMap.OverView",
//     "AMap.ToolBar",
//     "AMap.MapType",
//     "AMap.PolyEditor",
//     "AMap.CircleEditor",
//     "AMap.Geocoder",
//     "AMap.MouseTool",
//     "AMap.PolyEditor",
//     "AMap.CircleEditor",
//     "AMap.Heatmap",
//     "AMap.Geolocation"
//   ]
// });
/* 高德地图 结束 */

/* 原生扩展 开始 */
Promise.prototype.finally = function (callback) {
  let P = this.constructor;
  return this.then(
    value => P.resolve(callback()).then(() => value),
    reason =>
      P.resolve(callback()).then(() => {
        throw reason;
      })
  );
};
/* 原生扩展 结束 */

// @ts-ignore
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
